import React, { PropsWithChildren } from 'react';
import { resourceType, roleAccessTypes } from '../../constants/RBAC';
import { NotFoundView } from '../../pages/not-found';
import { useCheckRBACAccess } from '../../utils/checkRBACAccess';

interface AccessGuardProps {
  resourceType: resourceType;
  roleAccessTypes: string | string[];
}

export function GuardedPage({
  children,
  resourceType,
  roleAccessTypes: roleAccessType = roleAccessTypes.read,
}: PropsWithChildren<AccessGuardProps>): React.ReactElement {
  const noProtection = !resourceType;
  const hasAccess =
    useCheckRBACAccess(resourceType, roleAccessType) || noProtection;

  if (!hasAccess) {
    return <NotFoundView />;
  }

  return <>{children}</>;
}
